module.exports = __webpack_public_path__ + "../resources/images/files-17634f329cd7a802c0c88cfb5b870da3.svg";